export default {
    VMS_SITE_LIST: 'Site List',
    VMS_SITE_CREATE: "Create Site",
    VMS_SITE_CREATE_SUCCESS: "New Site Create Successful",
    VMS_SITE_MODIFY: "Modify Site",
    VMS_SITE_MODIFY_SUCCESS: "Site Modify Successful",
    VMS_SITE_CODE: 'Code',
    VMS_SITE_CODE_REQUIRED: 'Please input code',
    VMS_SITE_NAME: 'Name ',
    VMS_SITE_NAME_REQUIRED: 'Please input name',
    VMS_SITE_SEQUENCE: 'Sequence',
    VMS_SITE_MSG_HAVE_CHILDREN: 'site exists location, please delete location first!',
    VMS_SITE_DATA_GROUP: 'Data Group',

    VMS_LOCATION_LIST: 'Location List',
    VMS_LOCATION_CREATE: "Create Location",
    VMS_LOCATION_CREATE_SUCCESS: "New Location Create Successful",
    VMS_LOCATION_MODIFY: "Modify Location",
    VMS_LOCATION_MODIFY_SUCCESS: "Location Modify Successful",
    VMS_LOCATION_SITE: 'Site',
    VMS_LOCATION_SITE_REQUIRED: 'Please selected in Location',
    VMS_LOCATION_CODE: 'Code',
    VMS_LOCATION_CODE_REQUIRED: 'Please input code',
    VMS_LOCATION_NAME: 'Name',
    VMS_LOCATION_NAME_REQUIRED: 'Please input name',
    VMS_LOCATION_SEQUENCE: 'Sequence',
    VMS_LOCATION_MSG_HAVE_CHILDREN: 'Location exists place, please delete place first!',

    VMS_AREA_LIST: 'Area List',
    VMS_AREA_CREATE: "Create Area",
    VMS_AREA_CREATE_SUCCESS: "New Area Create Successful",
    VMS_AREA_MODIFY: "Modify Area",
    VMS_AREA_MODIFY_SUCCESS: "Area Modify Successful",
    VMS_AREA_LOCATION: 'Location',
    VMS_AREA_LOCATION_REQUIRED: 'Please selected in Area',
    VMS_AREA_CODE: 'Code',
    VMS_AREA_CODE_REQUIRED: 'Please input code',
    VMS_AREA_NAME: 'Name',
    VMS_AREA_NAME_REQUIRED: 'Please input name',
    VMS_AREA_TYPE: 'Type',
    VMS_AREA_TYPE_REQUIRED: 'Please input type',
    VMS_AREA_SEQUENCE: 'Sequence',
    VMS_AREA_TYPE_NORMAL: "Normal Office",
    VMS_AREA_TYPE_SPECIAL: "Special Office",

    VMS_VISITOR_TYPE: 'Visitor Type',
    VMS_VISITOR_TYPE_CREATE: 'Create Visitor Type',
    VMS_VISITOR_TYPE_CREATE_SUCCESS: 'Visitor Type Create Successful',
    VMS_VISITOR_TYPE_MODIFY: 'Modify Visitor Type',
    VMS_VISITOR_TYPE_MODIFY_SUCCESS: 'Visitor Type Modify Successful',
    VMS_VISITOR_TYPE_CODE: 'Code',
    VMS_VISITOR_TYPE_CODE_REQUIRED: 'Please input code',
    VMS_VISITOR_TYPE_NAME: 'Name',
    VMS_VISITOR_TYPE_NAME_REQUIRED: 'Please input name',
    VMS_VISITOR_TYPE_VALUE: 'Value',
    VMS_VISITOR_TYPE_VALUE_REQUIRED: 'Please input value',
    VMS_VISITOR_TYPE_SEQUENCE: 'Sequence',
    VMS_VISITOR_TYPE_WORKFLOW_FORM: 'Workflow Form',

    VMS_VISIT_REQUEST_UPDATE_SUCCESS: "Visit Request Update Successful",
    VMS_VISIT_REQUEST_NUMBER: 'Request Number',
    VMS_VISIT_REQUEST_APPLY_DATE: 'Apply Date',
    VMS_VISIT_REQUEST_STATUS: 'Request Status',
    VMS_VISIT_REQUEST_STATUS_NEW: 'New',
    VMS_VISIT_REQUEST_STATUS_APPROVING: 'Approving',
    VMS_VISIT_REQUEST_STATUS_APPROVED: 'Approved',
    VMS_VISIT_REQUEST_STATUS_REJECTED: 'Rejected',
    VMS_VISIT_REQUEST_STATUS_EXPIRED: 'Expired',
    VMS_VISIT_REQUEST_STATUS_COMPLETED: 'Complete',
    VMS_VISIT_REQUEST_STATUS_CANCELED: 'Canceled',

    VMS_VISIT_REQUEST_GENERAL_INFO: 'Visit Request Basic',
    VMS_VISIT_REQUEST_VISITOR_INFO: 'Visitor Info',
    VMS_VISIT_REQUEST_HOST_INFO: 'Visit Host Info',
    VMS_VISIT_REQUEST_CONFIRM_INFO: 'Confirm Info',
    VMS_VISIT_REQUEST_REGISTER_COMPLETE: 'Registration Complete',
    VMS_VISIT_REQUEST_PLACE: 'Place',
    VMS_VISIT_REQUEST_PLACE_SELECT: 'Select Place',
    VMS_VISIT_REQUEST_PLACES_REQUIRED: 'Please select place',
    VMS_VISIT_REQUEST_VISITORS_REQUIRED: 'Please input visitors',
    VMS_VISIT_REQUEST_ARRIVE_START_DATE: 'Arrival Start Date',
    VMS_VISIT_REQUEST_ARRIVE_END_DATE: 'Arrival End Date',
    VMS_VISIT_REQUEST_ARRIVE_START_TIME: "Start Time",
    VMS_VISIT_REQUEST_ARRIVE_END_TIME: "End Time",
    VMS_VISIT_REQUEST_ARRIVE_DATE: 'Arrival Date',
    VMS_VISIT_REQUEST_ARRIVE_TIME: 'Arrival Time',
    VMS_VISIT_REQUEST_ARRIVE_TIME_SELECT: 'Select Arrival Time',
    VMS_VISIT_REQUEST_ARRIVE_TIME_REQUIRED: 'Please input arrival time',
    VMS_VISIT_REQUEST_SITE: 'Visit Building',
    VMS_VISIT_REQUEST_PURPOSE_TYPE: 'Visit Purpose',
    VMS_VISIT_REQUEST_PURPOSE: 'Visit Reason',
    VMS_VISIT_REQUEST_PURPOSE_LOADING: 'Loading',
    VMS_VISIT_REQUEST_PURPOSE_DISCHARGE: 'Discharge',
    VMS_VISIT_REQUEST_PURPOSE_REQUIRED: "Please input visit reason",
    VMS_VISIT_REQUEST_EMPLOYEE_ENTITY: 'Employee Entity',
    VMS_VISIT_REQUEST_VISITOR_COUNT: "Visitor Count",
    VMS_VISITOR_ID_TYPE_ID: "ID Card",
    VMS_VISITOR_ID_TYPE_PASSPORT: "Passport",
    VMS_VISIT_REQUEST_INVITE_SUCCESS: 'Visitor invite successful.',
    VMS_VISIT_REQUEST_REGISTER_SUCCESS: 'Visitor register successful.',
    VMS_VISIT_REQUEST_WITHDRAW_SUCCESS: 'Visit request withdraw successful',

    VMS_VISITOR_REQUEST_HISTORY: "Visit History",
    VMS_VISITOR_MSG_ID_NUMBER_FORMAT_ERROR: "Please input correctly id Card no",

    VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE: 'Apply Source',
    VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_EMPLOYEE_WEB: 'Employee Web Invitation',
    VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_EMPLOYEE_APPLET: 'Employee Applet Invitation',
    VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_MANAGER_WEB: 'Manager Web Create',
    VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_VISITOR_APPLET: 'Visitor Applet Registration',
    VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_VISITOR_MOBILE_WEB: "Visitor Mobile Web",

    VMS_VISIT_REQUEST_HOST_MOBILE: 'Employee Mobile',
    VMS_VISIT_REQUEST_HOST_MOBILE_SEARCH: 'Please input host mobile and search',
    VMS_VISIT_REQUEST_HOST_NAME_SEARCH: 'Please input host name and search',

    VMS_VISIT_REQUEST_HOST_STAFF_NUMBER: 'Employee Staff Code',
    VMS_VISIT_REQUEST_HOST_STAFF_NUMBER_REQUIRED: 'Please input employee staff number',

    VMS_VISIT_REQUEST_HOST_MOBILE_REQUIRED: 'Please input employee mobile',
    VMS_VISIT_REQUEST_HOST_EMAIL: 'Employee Email',
    VMS_VISIT_REQUEST_HOST_EMAIL_REQUIRED: 'Please input employee email',
    VMS_VISIT_REQUEST_HOST_NAME: 'Employee Name',
    VMS_VISIT_REQUEST_DEPARTMENT:'Employee Department',
    VMS_VISIT_REQUEST_HOST_LAST_NAME: 'Employee Last Name',
    VMS_VISIT_REQUEST_HOST_LAST_NAME_REQUIRED: 'Please input employee last name',
    VMS_VISIT_REQUEST_HOST_FIRST_NAME: 'Employee First Name',
    VMS_VISIT_REQUEST_HOST_FIRST_NAME_REQUIRED: 'Please input employee first name',
    VMS_VISIT_REQUEST_HOST_LAST_INFO_RELOAD: 'Reception information loading',
    VMS_VISIT_REQUEST_HOST_LAST_INFO_RELOAD_SUCCESS: 'Reception information load successful.',
    VMS_VISIT_REQUEST_HOST_LAST_INFO_RELOAD_CONFIRM: 'This receptionist has a history record. Do you need to load the latest information of this receptionist?',
    VMS_VISIT_REQUEST_HOST_SUPERVISOR_NAME: 'Host Supervisor Name',
    VMS_VISIT_REQUEST_HOST_SUPERVISOR_EMAIL: 'Host Supervisor Email',
    VMS_VISIT_REQUEST_HOST_DEPARTMENT_NAME: 'Host Company',
    VMS_VISIT_REQUEST_HOST_DEPARTMENT_NAME_REQUIRED: 'Please input host department',
    VMS_VISIT_REQUEST_HOST_NAME_REQUIRED: 'Please input employee name',
    VMS_VISIT_REQUEST_HOST_NOT_FOUND: 'Host not found',
    VMS_VISIT_REQUEST_HOST_SELECT: "Select Host",
    VMS_VISIT_REQUEST_VISITOR_SELECT: 'Select Visitor',

    VMS_VISIT_REQUEST_REGISTER_SUBMIT_SUCCESS: 'Visitor Registration Submit Succeed.',
    VMS_VISIT_REQUEST_REGISTER_ANOTHER_ONE: 'Registration another one',
    VMS_VISIT_REQUEST_REGISTER_STEP_HOST_INFO: 'Internal Employee Info',
    VMS_VISIT_REQUEST_REGISTER_STEP_HOST_INFO_ALERT: 'After filling in the receptionist information once, it can be automatically filled in through employee number inquiry',
    VMS_VISIT_REQUEST_REGISTER_STEP_VISITOR_INFO: 'Visitor Info',
    VMS_VISIT_REQUEST_REGISTER_STEP_VISITOR_INFO_ALERT: 'After filling in visitor information once, it can be automatically filled in by querying through mobile phone number',
    VMS_VISIT_REQUEST_REGISTER_STEP_VISITOR_VEHICLE: 'Visitor Vehicle',
    VMS_VISIT_REQUEST_REGISTER_STEP_CONFIRM_INFO: 'Confirm Info',
    VMS_VISIT_REQUEST_REGISTER_STEP_CONSENT_LETTER: 'Consent Letter',
    VMS_VISIT_REQUEST_REGISTER_STEP_COMPLETE: 'Complete',
    VMS_VISIT_REQUEST_REGISTER_STEP_TRAINING: 'Training&Test',
    VMS_VISIT_REQUEST_REGISTER_STEP_SUBMIT: 'Submit',
    VMS_VISIT_REQUEST_DETAIL: 'Visit Request Detail',
    VMS_VISIT_REQUEST_PENDING_APPROVAL_LIST: 'Pending Approval List',
    VMS_VISIT_REQUEST_CLASSIFY: 'Classify',
    VMS_VISIT_REQUEST_CLASSIFY_NONE: 'None',
    VMS_VISIT_REQUEST_CLASSIFY_VISITOR: 'Visitor',
    VMS_VISIT_REQUEST_CLASSIFY_CONSTRUCTION: 'Construction',
    VMS_VISIT_REQUEST_CLASSIFY_SHIPPING: 'Loading and Unloading',
    VMS_VISIT_REQUEST_CLASSIFY_SPECIAL_VEHICLE: 'Special Vehicle',
    VMS_VISIT_REQUEST_CLASSIFY_EMPLOYEE_VEHICLE: 'Employee Vehicle',
    VMS_VISIT_REQUEST_APPLICANT_INFO: 'Applicant Information',
    VMS_VISIT_REQUEST_APPLICANT_STAFF_NUMBER: 'Applicant Staff Number',
    VMS_VISIT_REQUEST_APPLICANT_NAME: 'Applicant Name',
    VMS_VISIT_REQUEST_EMPLOYEE_VEHICLE_SUBMIT_SUCCESS: 'Employee Vehicle Apply Submit Successfully.',
    VMS_VISIT_REQUEST_DUPLICATE_APPOINTMENTS_NOT_ALLOWED: "Unfinished access appointments within the same validity period, and duplicate applications are not allowed",

    // 携带货品和运输物品
    VMS_VISIT_REQUEST_TRANSPORT_GOODS: "Transport Goods",
    VMS_VISIT_REQUEST_PERSONAL_GOODS_FLAG: "Carrying Personal Goods",
    VMS_VISIT_REQUEST_PERSONAL_GOODS_DESCRIPTION: "Personal Goods Description",

    // 第二接待者
    VMS_VISIT_REQUEST_HOST_2ND: "Host2",
    VMS_VISIT_REQUEST_HOST_NAME_2ND: "Host Name2",
    VMS_VISIT_REQUEST_HOST_MOBILE_2ND: "Host Mobile2",
    VMS_VISIT_REQUEST_HOST_DEPARTMENT_2ND: "Host Department2",

    VMS_REQUEST_VISITOR_REGISTER: 'Visitor Registration',
    VMS_REQUEST_VISITOR_REGISTER_INFO_FILL: 'Visitor Registration Info Fill',

    VMS_REQUEST_VISITOR_REGISTER_DESC: 'Registration basic information of visitors and contact persons, and complete visitor registration',
    VMS_REQUEST_VISITOR_CHECKIN: "Visitor checkin",
    VMS_REQUEST_VISITOR_CHECKIN_TIME: 'Sign In Time',
    VMS_REQUEST_VISITOR_CHECKIN_SUCCESSFUL: 'Check in successful, please wait for confirmation from the receptionist',
    VMS_REQUEST_VISITOR_CHECKIN_SUCCESSFUL_AUTO_CLOSE: 'Automatically close the check-in window after {seconds}s',
    VMS_REQUEST_VISITOR_CHECKIN_LOADING: 'Check in data submission in progress',
    VMS_REQUEST_VISITOR_CHECKOUT: 'Checkout',
    VMS_REQUEST_VISITOR_CHECKOUT_TIME: 'Sign Out Time',
    VMS_REQUEST_VISITOR_CHECKOUT_READER: 'Check Out Gate',
    VMS_REQUEST_VISITOR_CHECKOUT_DESC: 'When visitors leave, they need to complete the check-out confirmation through their ID card or card number',
    VMS_REQUEST_VISITOR_CHECKOUT_SUCCESS: 'Visitor Checkout Succeed.',
    VMS_REQUEST_VISITOR_CHECKOUT_CONFIRM: 'Are you sure you want to sign out and return the card？',
    VMS_REQUEST_VISITOR_CHECKOUT_CARD_NUMBER_DIFFERENT: 'The bound card does not match the card entered this time. Are you sure you want to use the changed card number to sign out？',
    VMS_REQUEST_VISITOR_SEARCH: 'Search Today Visitor',
    VMS_REQUEST_VISITOR_SEARCH_PLACEHOLDER: 'Please enter/scan the visitor\'s ID number or access card number',
    VMS_REQUEST_VISITOR_CONFIRM_INFO: 'Visitor Information Confirmation',
    VMS_REQUEST_VISITOR_CHECKOUT_COMPLETE: 'Checkout Complete',
    VMS_REQUEST_VISITOR_CHECKOUT_ANOTHER_ONE: 'Checkout another one',
    VMS_REQUEST_VISITOR_NOT_FOUND: 'No visitor information found',
    VMS_REQUEST_VISITOR_ACCESS_IN: "Access In",
    VMS_REQUEST_VISITOR_ACCESS_IN_TIME: 'Access In Time',
    VMS_REQUEST_VISITOR_ACCESS_IN_READER: 'Access In Gate',
    VMS_REQUEST_VISITOR_ACCESS_OUT: 'Access Out',
    VMS_REQUEST_VISITOR_ACCESS_OUT_TIME: 'Access Out Time',
    VMS_REQUEST_VISITOR_ACCESS_OUT_READER: "Access Out Gate",

    VMS_REQUEST_VISITOR_MANAGEMENT: 'Visitor Management',
    VMS_REQUEST_VISITOR_MANAGEMENT_DESC: 'Manage visitor lists, display visitor identity information and receptionist information',

    VMS_REQUEST_VISITOR_INFO: 'Visitor Information',
    VMS_REQUEST_VISITOR_LIST: 'Personnel List',
    VMS_REQUEST_VISITOR_DETAIL: 'Visitor Detail',
    VMS_REQUEST_VISITOR_CREATE: 'Create Personnel Data',
    VMS_REQUEST_VISITOR_MODIFY: 'Modify Personnel Data',
    VMS_REQUEST_VISITOR_GENERAL_INFO: 'Visitor General Info',
    VMS_REQUEST_VISITOR_VISIT_REQUEST_INFO: 'Visitor Request Info',

    VMS_REQUEST_VISITOR_VEHICLE_INFO: 'Driver Vehicle Info',
    VMS_REQUEST_VISITOR_ARRIVE_DATE: 'Arrival Date',
    VMS_REQUEST_VISITOR_ARRIVE_START_DATE_REQUIRED: 'Please select start date',
    VMS_REQUEST_VISITOR_ARRIVE_END_DATE_REQUIRED: 'Please select end date',
    VMS_REQUEST_VISITOR_VISIT_CODE: "Visit Code",
    VMS_REQUEST_VISITOR_VISIT_CODE_REQUIRED: "Please input visit code",
    VMS_REQUEST_VISITOR_VISIT_CODE_INVALID: "The visitor code is invalid. Please confirm if it is a valid visitor code for the day.",
    VMS_REQUEST_VISITOR_VISIT_CODE_VERIFY: "Verify Visit Code",
    VMS_REQUEST_VISITOR_VISIT_CODE_TIMEOUT: "The visitor code has timed out. Please refresh to obtain the latest visitor code.",
    VMS_REQUEST_VISITOR_VISIT_CODE_QRCODE: "QRCode",

    VMS_REQUEST_VISITOR_NAME: 'Visitor Name',
    VMS_REQUEST_VISITOR_NAME_REQUIRED: 'Please input visitor name',
    VMS_REQUEST_VISITOR_LAST_NAME: 'Visitor Last Name',
    VMS_REQUEST_VISITOR_LAST_NAME_REQUIRED: 'Please input visitor last name',
    VMS_REQUEST_VISITOR_FIRST_NAME: 'Visitor First Name',
    VMS_REQUEST_VISITOR_FIRST_NAME_REQUIRED: 'Please input visitor first name',
    VMS_REQUEST_VISITOR_MOBILE: 'Visitor Mobile Number',
    VMS_REQUEST_VISITOR_MOBILE_REQUIRED: 'Please input visitor mobile',
    VMS_REQUEST_VISITOR_MOBILE_FORMAT_ERROR: 'Please input correctly mobile',
    VMS_REQUEST_VISITOR_EMAIL: 'Visitor Email',
    VMS_REQUEST_VISITOR_EMAIL_REQUIRED: 'Please input visitor email',
    VMS_REQUEST_VISITOR_EMAIL_FORMAT_ERROR: "Please input correctly email",
    VMS_REQUEST_VISITOR_EMAIL_TIPS: "Please fill in your contact email, relevant access notifications will be sent to this email",
    VMS_REQUEST_VISITOR_COMPANY: 'Visitor Company',
    VMS_REQUEST_VISITOR_COMPANY_REQUIRED: 'Please input visitor company',
    VMS_REQUEST_VISITOR_ID_TYPE: 'ID Type',
    VMS_REQUEST_VISITOR_ID_NUMBER: 'ID Number',
    VMS_REQUEST_VISITOR_EMPLOYEE_NO: 'Employee No',
    VMS_REQUEST_VISITOR_ID_TYPE_REQUIRED: 'Please input ID Type',
    VMS_REQUEST_VISITOR_EMPLOYEE_NO_REQUIRED: 'Please input Employee No',

    VMS_REQUEST_VISITOR_ID_NUMBER_REQUIRED: 'Please input ID number',
    VMS_REQUEST_VISITOR_TYPE: 'Visitor Type',
    VMS_REQUEST_VISITOR_JOB: 'Job',
    VMS_REQUEST_VISITOR_DRIVE_TYPE: 'Drive Type',
    VMS_REQUEST_VISITOR_DRIVE_TYPE_NONE: 'None',
    VMS_REQUEST_VISITOR_DRIVE_TYPE_DRIVER: 'Driver',
    VMS_REQUEST_VISITOR_DRIVE_TYPE_PASSENGER: 'Passenger',
    VMS_REQUEST_VISITOR_PLATE_NUMBER: 'Plate Number',
    VMS_REQUEST_VISITOR_PLATE_NUMBER_REQUIRED: 'Please input plate number',
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR: 'Plate Color',
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_REQUIRED: 'Please input plate Color',
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_BLUE: "Blue",
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_YELLOW: "Yellow",
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_WHITE: "White",
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_BLACK: "Black",
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_GREEN: "New Energy Green",
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_OTHER: "Other",
    VMS_REQUEST_VISITOR_VEHICLE_USE_TYPE: 'Vehicle Use Type',
    VMS_REQUEST_VISITOR_VEHICLE_TYPE: 'Vehicle Type',
    VMS_REQUEST_VISITOR_VEHICLE_TYPE_REQUIRED: 'Please input vehicle type',
    VMS_REQUEST_VISITOR_VEHICLE_TYPE_CAR: "Car",
    VMS_REQUEST_VISITOR_VEHICLE_TYPE_TRUCK: "Truck",
    VMS_REQUEST_VISITOR_VEHICLE_TYPE_MOTORCYCLE: "Motorcycle",
    VMS_REQUEST_VISITOR_VEHICLE_TYPE_BUS: "Bus",
    VMS_REQUEST_VISITOR_VEHICLE_TYPE_SPECIAL: "Special Vehicle",
    VMS_REQUEST_VISITOR_VEHICLE_TYPE_OTHER: "Other",
    VMS_REQUEST_VISITOR_VEHICLE_REGISTRATION_DATE: "Registration Date",
    VMS_REQUEST_VISITOR_VEHICLE_REGISTRATION_DATE_REQUIRED: "Please input registration date",
    VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE: "Fuel Type",
    VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_REQUIRED: "Please input fuel type",
    VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_GAS: "Gas",
    VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_DIESEL: "Diesel",
    VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_NATURAL_GAS: "Natural Gas",
    VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_ELECTRIC: "Electric",
    VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_OTHER: "Other",
    VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD: "Emission Standard",
    VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_REQUIRED: "Please input emission standard",
    VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_III: "National III",
    VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_IV: "National IV",
    VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_V: "National V",
    VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_VI: "National VI",
    VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_ELECTRIC: "Electric",
    VMS_REQUEST_VISITOR_ACCESS_INFO: 'Access Info',
    VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER: 'Access Card Number',
    VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER_PLACEHOLDER: 'Please input access card number',
    VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER_BIND: 'Bind Card',
    VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER_BIND_SUCCESS: 'Visitor card binding successful, check-in completed',
    VMS_REQUEST_VISITOR_LAST_INFO_RELOAD: 'Visitor information loading',
    VMS_REQUEST_VISITOR_LAST_INFO_RELOAD_SUCCESS: 'Visitor information load successful',
    VMS_REQUEST_VISITOR_LAST_INFO_RELOAD_CONFIRM: 'This visitor has a history record. Do you need to load the latest information of this visitor?',
    VMS_REQUEST_VISITOR_EMPLOYEE_EMAIL: "Employee Email",
    VMS_REQUEST_VISITOR_QUICK_SELECT: 'History visitor quick select',
    VMS_REQUEST_VISITOR_CONSTRUCTION_ORDER_NUMBER: 'Construction Order Number',
    VMS_REQUEST_VISITOR_STATUS: 'Visitor Status',
    VMS_REQUEST_VISITOR_STATUS_VISIT_WAITING: 'Waiting',
    VMS_REQUEST_VISITOR_STATUS_CHECK_IN_PENDING: "CheckIn Pending",
    VMS_REQUEST_VISITOR_STATUS_CHECK_IN: "CheckIn",
    VMS_REQUEST_VISITOR_STATUS_CHECK_OUT: "CheckOut",
    VMS_REQUEST_VISITOR_STATUS_CHECK_IN_REJECT: "CheckIn Reject",
    VMS_REQUEST_VISITOR_STATUS_EXPIRED: "Expired",
    VMS_REQUEST_VISITOR_STATUS_CANCEL: "Cancel",

    VMS_REQUEST_VISITOR_HISTORY_LIST: "History Visitors",

    // 驾驶人信息
    VMS_REQUEST_VISITOR_DRIVER_NAME: 'Driver Name',
    VMS_REQUEST_VISITOR_DRIVER_LAST_NAME: 'Driver Last Name',
    VMS_REQUEST_VISITOR_DRIVER_LAST_NAME_REQUIRED: 'Please input driver last name',
    VMS_REQUEST_VISITOR_DRIVER_FIRST_NAME: 'Driver First Name',
    VMS_REQUEST_VISITOR_DRIVER_FIRST_NAME_REQUIRED: 'Please input driver first name',
    VMS_REQUEST_VISITOR_DRIVER_MOBILE: 'Driver Mobile',
    VMS_REQUEST_VISITOR_DRIVER_MOBILE_REQUIRED: 'Please input driver mobile',
    VMS_REQUEST_VISITOR_DRIVER_ID_NUMBER: 'Driver ID Number',
    VMS_REQUEST_VISITOR_DRIVER_ID_NUMBER_REQUIRED: 'Please input driver ID number',
    VMS_REQUEST_VISITOR_DRIVER_COMPANY: 'Driver Company',
    VMS_REQUEST_VISITOR_DRIVER_COMPANY_REQUIRED: 'Please input driver company',
    VMS_REQUEST_VISITOR_SPECIAL_VEHICLE_CERTIFICATE_UPLOAD: 'Special vehicle certificate upload',
    VMS_REQUEST_VISITOR_SPECIAL_VEHICLE_CERTIFICATE_UPLOAD_REQUIRED: ' Please upload special vehicle certificate',
    VMS_REQUEST_VISITOR_DRIVER_LICENSE_UPLOAD: 'Driving License Upload',
    VMS_REQUEST_VISITOR_DRIVER_LICENSE_UPLOAD_REQUIRED: 'Please upload driving license',
    VMS_REQUEST_VISITOR_VEHICLE_LICENSE_UPLOAD: 'Vehicle Registration Certificate Upload',
    VMS_REQUEST_VISITOR_VEHICLE_LICENSE_UPLOAD_REQUIRED: 'Please upload vehicle registration certificate',
    VMS_REQUEST_VISITOR_PHOTO: 'Photo',
    VMS_REQUEST_VISITOR_PHOTO_CAPTURE_TIPS: 'Please take photos for facial recognition authorization authentication',
    VMS_REQUEST_VISITOR_PHOTO_VERIFY_FAILED: 'Facial photo verification failed, please retake',
    VMS_REQUEST_VISITOR_PHOTO_DOWNLOAD: 'Download Photo',
    VMS_REQUEST_VISITOR_CONSTRUCTION_ORDER_UPLOAD: 'Construction order upload',
    VMS_REQUEST_VISITOR_CONSTRUCTION_CAPTURE_TIPS: 'Please hold the construction order and aim it at the camera to take a photo',
    VMS_REQUEST_VISITOR_SPECIAL_VEHICLE_CAPTURE_TIPS: 'Please hold the special vehicle license and aim it at the camera to take a photo',
    VMS_REQUEST_VISITOR_ATTACH_FILE: 'Attach File',
    VMS_REQUEST_VISITOR_ATTACH_FILE_DOWNLOAD: 'Attach File Download',
    VMS_REQUEST_VISITOR_ATTACH_FILE_NAME: 'Attach File Name',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY: 'File Classify',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_SPECIAL_VEHICLE: 'Special Vehicle Certificate',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_DRIVER_LICENSE: 'Driver License',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_VEHICLE_LICENSE: 'Vehicle License',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_CONSTRUCTION_ORDER: 'Construction Order',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_QUALIFICATION_CERTIFICATE: 'Professional qualification certificate',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_ROAD_OPERATION_LICENSE: 'Road operation permit',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_VEHICLE_SIDE_PHOTO: 'Panoramic photo of the vehicle\'s side profile',
    VMS_REQUEST_VISITOR_ZK_ADD_PERSON_FAILED: "Failed to add license plate, personnel number does not match license plate number",
    VMS_REQUEST_VISITOR_TRAINING_NON_ANSWER: "Please answer the question",
    VMS_REQUEST_VISITOR_TRAINING_SCORE_REQUIRED: "Not meeting the minimum score requirement, please confirm these questions",
    VMS_REQUEST_VISITOR_TRAINING_SKIP: "Training records are valid for 12 months, skip this training evaluation",

    // 访问场所
    VMS_REQUEST_PLACE_LIST: "Visit Place List",
    VMS_REQUEST_PLACE_AREA_NAME: "Area Name",
    VMS_REQUEST_PLACE_AREA_CODE: "Area Code",
    VMS_REQUEST_PLACE_AREA_MANAGER_NAME: "Manager Name",
    VMS_REQUEST_PLACE_AREA_MANAGER_EMAIL: "Manager Email",

    // 访客访问记录
    VMS_VISITOR_ACCESS_LOG_ACCESS_DATE: 'Access Date',
    VMS_VISITOR_ACCESS_LOG_ACCESS_TIME: 'Access Time',
    VMS_VISITOR_ACCESS_LOG_ACCESS_READER: 'Access Reader',
    VMS_VISITOR_ACCESS_LOG_ACCESS_CARD_NUMBER: 'Access Card Number',
    VMS_VISITOR_ACCESS_LOG_ACCESS_DIRECTION: 'Access Direction',
    VMS_VISITOR_ACCESS_LOG_ACCESS_DIRECTION_CHECKIN: 'Checkin',
    VMS_VISITOR_ACCESS_LOG_ACCESS_DIRECTION_CHECKOUT: 'Checkout',
    VMS_VISITOR_ACCESS_LOG_LIST: "Visitor access records",
    VMS_VISITOR_ACCESS_LOG_LIST_FETCH: "Fetch Visitor Access Log",

    // 访客卡管理
    VMS_CARD_BUTTON_SHOW_FAILED_ONLY: "Show Failed",
    VMS_CARD_SEND_CARD: "Assign pass cards",
    VMS_CARD_IMPORT: "Import Visitor Card",
    VMS_CARD_NUMBER: "Card Number",
    VMS_CARD_STATUS: "Card Status",
    VMS_CARD_STATUS_AVAILABLE: "Available",
    VMS_CARD_STATUS_BINDING: "Binding",
    VMS_CARD_CLASSIFY: "Classify",
    VMS_CARD_CLASSIFY_PERSON: "Personnel Card",
    VMS_CARD_CLASSIFY_VEHICLE: "Vehicle Card",
    VMS_CARD_TERMINAL: "Terminal",
    VMS_CARD_NUMBER_DUPLICATE: "Duplicate Card number",
    VMS_CARD_NUMBER_REQUIRED: "Card number is required",
    VMS_CARD_STATUS_REQUIRED: "Card status is required",
    VMS_CARD_CLASSIFY_REQUIRED: "Card classify is required",
    VMS_CARD_AVAILABLE_CARD_NO_FOUND: "Available visitor card not found",
    VMS_CARD_SEND_CARD_NOTICE: "Please assign the following card number to the visitor, or to regain the card number, click the Refresh button",
    VMS_CARD_SEND_CARD_FAILED: "Failed to assign card numbers, contact your administrator to confirm that the card pool data is correct.",

    // 访客黑名单管理
    VMS_VISITOR_BLACK_LIST_ADD: "Add Visitor Blacklist",
    VMS_VISITOR_BLACK_LIST_ADD_SUCCESS: "Add Visitor Blacklist Successful.",
    VMS_VISITOR_BLACK_LIST_MODIFY: "Modify Visitor Blacklist",
    VMS_VISITOR_BLACK_LIST_MODIFY_SUCCESS: "Modify Visitor Blacklist Successful.",
    VMS_VISITOR_BLACK_LIST: "Visitor Black List",
    VMS_VISITOR_FIRST_NAME: "First Name",
    VMS_VISITOR_FIRST_NAME_REQUIRED: "First name is required",
    VMS_VISITOR_LAST_NAME: "Last Name",
    VMS_VISITOR_LAST_NAME_REQUIRED: "Last name is required",
    VMS_VISITOR_NAME: "Name",
    VMS_VISITOR_EMAIL: "Email",
    VMS_VISITOR_MOBILE: "Mobile",
    VMS_VISITOR_PHOTO: "Photo",
    VMS_VISITOR_COMPANY: "Company",
    VMS_VISITOR_ID_TYPE: "IdType",
    VMS_VISITOR_ID_NUMBER: "Id Number",
    VMS_VISITOR_ID_NUMBER_REQUIRED: 'Please input ID number',
    VMS_VISITOR_BLACK_LIST_REGISTERED_WARNING: 'The visitor is registered on the blacklist. Are you sure you want to continue registering?',


    VMS_VISITOR_CARD_NUMBER_USED_WARNING: 'The card number has not been checked out yet, please choose another card number.',
    // 访客自助终端管理
    VMS_TERMINAL_DEVICE_LIST: "Device List",
    VMS_TERMINAL_CODE: "Code",
    VMS_TERMINAL_NAME: "Name",
    VMS_TERMINAL_CODE_REQUIRED: "Terminal code is required.",
    VMS_TERMINAL_CODE_DUPLICATE: "Terminal code is duplicate",
    VMS_TERMINAL_WELCOME_TITLE: "Welcome Albemarle",
    VMS_TERMINAL_WELCOME_SIGN_IN_ZH: "持 访 客 码 签 到",
    VMS_TERMINAL_WELCOME_SIGN_IN_EN: "Visit Code Check In",
    VMS_TERMINAL_WELCOME_REGISTER_ZH: "现 场 预 约 登 记",
    VMS_TERMINAL_WELCOME_REGISTER_EN: "On Site Registration",
    VMS_TERMINAL_WELCOME_SIGN_IN_SCAN_HELP: "Please present the entrance QR code and aim it at the scanning slot of the machine for quick check-in",
    VMS_TERMINAL_STEP_VISIT_INFO: "Visit Info",
    VMS_TERMINAL_STEP_ID_NUMBER: "ID Number",
    VMS_TERMINAL_STEP_CONSTRUCTION_ORDER: "Construction Order",
    VMS_TERMINAL_STEP_SPECIAL_VEHICLE_LICENSE: "Special Vehicle License",
    VMS_TERMINAL_STEP_PORTRAIT: "Portrait",
    VMS_TERMINAL_STEP_ACCESS_CODE: "Access Code",
    VMS_TERMINAL_STEP_ACCESS_CODE_DESCRIPTION: "Please print or take a photo of the access code, and use it to pass",
    VMS_TERMINAL_STEP_FINISH: "Finish",
    VMS_TERMINAL_STEP_VEHICLE_ENVIRONMENTAL: "Vehicle Environmental",

    VMS_VISITOR_BTN_CHECKOUT: "Checkout",
    VMS_VISITOR_MSG_CHECKOUT_CONFIRM: "Please confirm checkout the visitor?",
    EXOS_ACCESS_RIGHT_MSG_ASSIGN_FAILED: "Exos permission setting failed, please contact the system administrator",
    EXOS_BADGE_MSG_NOT_FOUND: "The card number cannot be found, please confirm",
    EXOS_ACCESS_RIGHT_MSG_BADGE_PERSON_NOT_FOUND: "The access card is invalid, please confirm",

    // 访问申请时间设定
    VMS_REQUEST_TIME_SETTING_DISABLE: 'Disable',
    VMS_REQUEST_TIME_SETTING_ENABLE: 'Enable',
    VMS_REQUEST_TIME_SETTING_FULL: 'Full',
    VMS_VISITOR_BTN_WITHDRAW: "Cancel Request",

    // 移动端
    VMS_MOBILE_WELCOME_EMPLOYEE_REGISTER:"Employee Registration",
    VMS_MOBILE_WELCOME_SELF_REGISTER: "Visitor Self Registration",
    VMS_MOBILE_WELCOME_SELF_EMPLOYEE_ENTRANCE: "Employee Entrance",
};

